module.exports = __webpack_public_path__ + "Roboto-medium.d08840599e05db7345652d3d417574a9.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/Roboto/Roboto-medium.ttf
// module id = 437
// module chunks = 8